import { render, staticRenderFns } from "./Partenaires.vue?vue&type=template&id=4969962a&scoped=true"
import script from "./Partenaires.vue?vue&type=script&lang=js"
export * from "./Partenaires.vue?vue&type=script&lang=js"
import style0 from "./Partenaires.vue?vue&type=style&index=0&id=4969962a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4969962a",
  null
  
)

export default component.exports